<template>
  <section :class="$options.name">
    <Loader v-if="loading"/>
    <header :class="$options.name + '__header'">
      <h2>Happy clients</h2>
      <nav :class="$options.name + '__nav'">
        <button
          :class="$options.name + '__navBtn'"
          @click="previous"
          aria-label="View previous testimonial"
        >
          <span>
            <Icon name="arrow-left" :size="14"/>
          </span>
        </button>
        <button
          :class="$options.name + '__navBtn'"
          @click="next"
          aria-label="View next testimonial"
        >
          <span>
            <Icon name="arrow-right" :size="14"/>
          </span>
        </button>
      </nav>
    </header>
    <section
      v-if="!errored && !loading"
      v-for="(item,index) in itemsFiltered"
      :key="index"
      :class="$options.name + '__wrapper'"
    >
      <transition name="fade" mode="out-in">
        <section :class="$options.name + '__item'">
          <RichText :class="$options.name + '__item--content'" :value="item.fields.testimonial"/>
          <footer :class="$options.name + '__item--author'">
            <h4>{{ item.fields.author }}</h4>
          </footer>
        </section>
      </transition>
    </section>
  </section>
</template>
<script>
import Icon from "@/components/Icon";
import Loader from "@/components/Loader";
import RichText from "@/components/RichText";
export default {
  name: "Testimonials",
  components: { Icon, Loader, RichText },
  computed: {
    itemsFiltered() {
      let start = this.active * this.quantity;
      let stop = (this.active + 1) * this.quantity;
      return this.testimonials.slice(start, stop);
    },
    itemsPaginated() {
      let pages = Math.ceil(this.testimonials.length / this.quantity);
      let array = Array.apply(null, { length: pages }).map(Number.call, Number);
      if (array.length > 1) {
        return array;
      }
    }
  },
  data() {
    return {
      active: 0,
      apiSpace: this.$store.state.apiSpace,
      apiToken: this.$store.state.apiToken,
      testimonials: [],
      errored: false,
      loading: true
    };
  },
  methods: {
    getTestimonials() {
      const contentful = require("contentful");
      const client = contentful.createClient({
        space: this.apiSpace,
        accessToken: this.apiToken
      });
      client
        .getEntries({
          content_type: "testimonial"
        })
        .then(entries => {
          this.testimonials = entries.items;
        })
        .catch(error => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    next() {
      if (this.active < this.itemsPaginated.length - 1) {
        this.active += 1;
      } else {
        this.active = 0;
      }
    },
    previous() {
      if (this.active > 0) {
        this.active -= 1;
      } else {
        this.active = this.itemsPaginated.length - 1;
      }
    },
    updateActive(value) {
      this.active = value;
    }
  },
  mounted() {
    this.getTestimonials();
  },
  props: {
    quantity: { default: 1, type: Number }
  }
};
</script>
<style lang="scss">
.Testimonials {
  &__header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    h2 {
      color: var(--base-mid);
    }
    + * {
      margin-top: rem(16);
    }
  }
  &__item {
    background-color: var(--contrast);
    border-radius: rem(4);
    box-shadow: 0 rem(16) rem(32) rem(-16) rgba(black, 0.25);
    overflow: hidden;
    &--content {
      padding: rem(16);
      @include breakpoint(s) {
        padding: rem(32);
      }
    }
    &--author {
      background-color: var(--base);
      color: var(--contrast);
      padding: rem(16);
      @include breakpoint(s) {
        padding: rem(16) rem(32);
      }
    }
  }
  &__nav {
    &Btn {
      @include smooth;
      align-items: center;
      background-color: var(--base);
      border-radius: 50%;
      color: white;
      cursor: pointer;
      display: inline-flex;
      height: rem(40);
      justify-content: center;
      width: rem(40);
      [data-theme="dark"] & {
        background-color: var(--contrast);
      }
      &:focus,
      &:hover,
      &--active {
        color: var(--highlight);
      }
      span {
        @include typeFamily(secondary);
        @include typeSize(l, m);
        font-weight: bold;
        position: relative;
        top: rem(-2);
      }
      + * {
        margin-left: rem(8);
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    @include smooth;
    transition-delay: 0.375s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>